var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHomeSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5937 0.136049L0.260404 8.13584C0.0984043 8.26034 -0.000795197 8.46274 4.80241e-06 8.66707V23.3334C3.81357e-05 23.6824 0.317605 24 0.666671 24H7.66667C8.01574 24 8.3333 23.6824 8.33334 23.3334V18.6667C8.33334 17.1778 9.51114 16.0001 11 16.0001C12.4889 16.0001 13.6667 17.1778 13.6667 18.6667V23.3334C13.6667 23.6824 13.9843 24 14.3333 24H21.3333C21.6824 24 22 23.6824 22 23.3334V8.66707C22 8.46274 21.9016 8.26034 21.7396 8.13584L11.4063 0.136049C11.1573 -0.0589839 10.8097 -0.0311839 10.5937 0.136049ZM11 1.50061L20.6667 8.98997V22.6667H15V18.6667C15 16.4623 13.2045 14.6668 11 14.6668C8.79554 14.6668 7 16.4623 7 18.6667V22.6667H1.33334V8.98997L11 1.50061Z",
    fill: "#4A5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHomeSolid);
export default __webpack_public_path__ + "static/media/ico-home-solid.a4f19a9b84848f293cc146e81e0e5e87.svg";
export { ForwardRef as ReactComponent };